import React from 'react';
import Linkify from 'linkify-react';
import lodash from 'lodash'
import EmojiMocha from '../lib/emoji-mocha';
import { NODE_TYPE_MESSAGE } from '../tinode/constants';
import MessagesUtil from '../tinode/messagesUtils.js';
import Helpers from '../lib/helpers';
import { DOMAIN_GROUP_INVITE } from '../config.js'

const MessageContent = {}

MessageContent.renderContent = (tinode, content, data) => {
  const { tags = {}, clickAction = true, handleClickTagAction = null, tagAll = false } = data

  if (tagAll) {
    content = content.replace("@@All", "@@All")
  }

  const tagRegex = /(@[\d|\+]+)(?=\s|$)/
  const tagAllRegex = /(@@All)(?=[\s.,!?":;'()]|$)/
  const emojiMochaRegex = EmojiMocha.getRegex()

  const regex = new RegExp(`${tagAllRegex.source}|${tagRegex.source}|${emojiMochaRegex.source}`, 'g')

  const arr = content.split(regex);

  if (Array.isArray(tags)) {
    for (let index = 0; index < tags.length; index++) {
      const tag = tags[index];
      const { msisdn, tag_name } = tag;
      const topicId = MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, msisdn);
      const topic = tinode.getTopicByName(topicId);
      let name = lodash.has(tag, 'name') ? tag.name : tag_name;
      if (topic && topic.getTopicName()) {
        name = topic.getTopicName();
      }
      const indexOf = arr.findIndex((item) => item === tag_name);
      if (indexOf !== -1) {
        const className = `contact ${clickAction ? '' : 'light'}`
        arr[indexOf] = React.createElement('span', {
          onClick: () => clickAction && handleClickTagAction ? handleClickTagAction(topicId) : null,
          className: className,
          key: index,
        }, name);
      }
    }
  }

  if (tagAll) {
    const indexOf = arr.findIndex((item) => typeof item === 'string' && item.includes('@@All'));
    if (indexOf !== -1) {
      const className = `contact ${clickAction ? '' : 'light'}`
      arr[indexOf] = React.createElement('span', {
        onClick: () => null,
        className: className,
        key: indexOf,
      }, arr[indexOf].replace("@@All", "@All"));
    }
  }
  const rsArray = arr.map((r) => {
    if (typeof r === 'string') {
      const img = EmojiMocha.EMOTICON_MAPS[r]
      if (img) {
        const urlRef = Helpers.getWebchatURL(`/img/emoticons-mocha/${img}.png`)
        return (<img className='emoticons-mocha' src={urlRef} />)
      } else {
        if (r.indexOf(DOMAIN_GROUP_INVITE) > -1) {
          return (<Linkify options={{
            render: ({
              url: ({ attributes, content }) => {
                return (<span
                  {...attributes}
                  className='qr-code-link'
                  onClick={() => tinode.showGroupInfo(content)}
                >{content}</span>)
              }
            })
          }}>
            {r}
          </Linkify>)
        } else {
          return (<Linkify options={{ target: '_blank' }}>
            {r}
          </Linkify>)
        }
      }
    }
    return r
  })

  return rsArray;
}

export default MessageContent